export default [
  { id: '30', name: 'Brasileira', nomePais: 'Brasil', codigo: 'BR' },
  { id: '1', name: 'Afegãne', nomePais: 'Afeganistão', codigo: 'AF' },
  { id: '2', name: 'Sul-africana', nomePais: 'África do Sul', codigo: 'ZA' },
  { id: '3', name: 'Albanesa', nomePais: 'Albânia', codigo: 'AL' },
  { id: '4', name: 'Alemã', nomePais: 'Alemanha', codigo: 'DE' },
  { id: '5', name: 'Andorrana', nomePais: 'Andorra', codigo: 'AD' },
  { id: '6', name: 'Angolana', nomePais: 'Angola', codigo: 'AO' },
  { id: '7', name: 'Anguilana', nomePais: 'Anguilla', codigo: 'AI' },
  { id: '8', name: 'De antártida', nomePais: 'Antártida', codigo: 'AQ' },
  { id: '9', name: 'Antiguana', nomePais: 'Antígua e Barbuda', codigo: 'AG' },
  { id: '10', name: 'Saudita', nomePais: 'Arábia Saudita', codigo: 'SA' },
  { id: '11', name: 'Argelina', nomePais: 'Argélia', codigo: 'DZ' },
  { id: '12', name: 'Argentina', nomePais: 'Argentina', codigo: 'AR' },
  { id: '13', name: 'Armênia', nomePais: 'Armênia', codigo: 'AM' },
  { id: '14', name: 'Arubana', nomePais: 'Aruba', codigo: 'AW' },
  { id: '15', name: 'Australiana', nomePais: 'Austrália', codigo: 'AU' },
  { id: '16', name: 'Austríaca', nomePais: 'Áustria', codigo: 'AT' },
  { id: '17', name: 'Azerbaidjana', nomePais: 'Azerbaijão', codigo: 'AZ' },
  { id: '18', name: 'Bahamense', nomePais: 'Bahamas', codigo: 'BS' },
  { id: '19', name: 'Bareinita', nomePais: 'Bahrein', codigo: 'BH' },
  { id: '20', name: 'Bengali', nomePais: 'Bangladesh', codigo: 'BD' },
  { id: '21', name: 'Barbadiana', nomePais: 'Barbados', codigo: 'BB' },
  { id: '22', name: 'Bielorrussa', nomePais: 'Belarus', codigo: 'BY' },
  { id: '23', name: 'Belga', nomePais: 'Bélgica', codigo: 'BE' },
  { id: '24', name: 'Belizenha', nomePais: 'Belize', codigo: 'BZ' },
  { id: '25', name: 'Beninense', nomePais: 'Benin', codigo: 'BJ' },
  { id: '26', name: 'Bermudense', nomePais: 'Bermudas', codigo: 'BM' },
  { id: '27', name: 'Boliviana', nomePais: 'Bolívia', codigo: 'BO' },
  { id: '28', name: 'Bósnia', nomePais: 'Bósnia-Herzegóvina', codigo: 'BA' },
  { id: '29', name: 'Botsuana', nomePais: 'Botsuana', codigo: 'BW' },
  { id: '31', name: 'Bruneana', nomePais: 'Brunei', codigo: 'BN' },
  { id: '32', name: 'Búlgara', nomePais: 'Bulgária', codigo: 'BG' },
  { id: '33', name: 'Burquinense', nomePais: 'Burkina Fasso', codigo: 'BF' },
  { id: '34', name: 'Burundinesa', nomePais: 'Burundi', codigo: 'BI' },
  { id: '35', name: 'Butanesa', nomePais: 'Butão', codigo: 'BT' },
  { id: '36', name: 'Cabo-verdiana', nomePais: 'Cabo Verde', codigo: 'CV' },
  { id: '37', name: 'Camaronesa', nomePais: 'Camarões', codigo: 'CM' },
  { id: '38', name: 'Cambojana', nomePais: 'Camboja', codigo: 'KH' },
  { id: '39', name: 'Canadense', nomePais: 'Canadá', codigo: 'CA' },
  { id: '40', name: 'Canarina', nomePais: 'Canárias', codigo: 'IC' },
  { id: '41', name: 'Cazaque', nomePais: 'Cazaquistão', codigo: 'KZ' },
  { id: '42', name: 'De ceuta e melilla', nomePais: 'Ceuta e Melilla', codigo: 'EA' },
  { id: '43', name: 'Chadiana', nomePais: 'Chade', codigo: 'TD' },
  { id: '44', name: 'Chilena', nomePais: 'Chile', codigo: 'CL' },
  { id: '45', name: 'Chinesa', nomePais: 'China', codigo: 'CN' },
  { id: '46', name: 'Cipriota', nomePais: 'Chipre', codigo: 'CY' },
  { id: '47', name: 'Cingapuriana', nomePais: 'Cingapura', codigo: 'SG' },
  { id: '48', name: 'Colombiana', nomePais: 'Colômbia', codigo: 'CO' },
  { id: '49', name: 'Comorense', nomePais: 'Comores', codigo: 'KM' },
  { id: '50', name: 'Congolesa', nomePais: 'Congo', codigo: 'CG' },
  { id: '51', name: 'Norte-coreana', nomePais: 'Coréia do Norte', codigo: 'KP' },
  { id: '52', name: 'Sul-coreana', nomePais: 'Coréia do Sul', codigo: 'KR' },
  { id: '53', name: 'Marfinense', nomePais: 'Costa do Marfim', codigo: 'CI' },
  { id: '54', name: 'Costarriquenha', nomePais: 'Costa Rica', codigo: 'CR' },
  { id: '55', name: 'Croata', nomePais: 'Croácia', codigo: 'HR' },
  { id: '56', name: 'Cubana', nomePais: 'Cuba', codigo: 'CU' },
  { id: '57', name: 'Curaçaense', nomePais: 'Curaçao', codigo: 'CW' },
  { id: '58', name: 'Chagossiana', nomePais: 'Diego Garcia', codigo: 'DG' },
  { id: '59', name: 'Dinamarquesa', nomePais: 'Dinamarca', codigo: 'DK' },
  { id: '60', name: 'Djibutiana', nomePais: 'Djibuti', codigo: 'DJ' },
  { id: '61', name: 'Dominiquense', nomePais: 'Dominica', codigo: 'DM' },
  { id: '62', name: 'Egípcia', nomePais: 'Egito', codigo: 'EG' },
  { id: '63', name: 'Salvadorenha', nomePais: 'El Salvador', codigo: 'SV' },
  { id: '64', name: 'Árabe', nomePais: 'Emirados Árabes Unidos', codigo: 'AE' },
  { id: '65', name: 'Equatoriana', nomePais: 'Equador', codigo: 'EC' },
  { id: '66', name: 'Eritreia', nomePais: 'Eritréia', codigo: 'ER' },
  { id: '67', name: 'Eslovaca', nomePais: 'Eslováquia', codigo: 'SK' },
  { id: '68', name: 'Eslovena', nomePais: 'Eslovênia', 'NomePais_int': 'Slovenia', codigo: 'SI' },
  { id: '69', name: 'Espanhola', nomePais: 'Espanha', codigo: 'ES' },
  { id: '70', name: 'Norte-americana', nomePais: 'Estados Unidos', codigo: 'US' },
  { id: '71', name: 'Estoniana', nomePais: 'Estônia', codigo: 'EE' },
  { id: '72', name: 'Etíope', nomePais: 'Etiópia', codigo: 'ET' },
  { id: '73', name: 'Fijiana', nomePais: 'Fiji', codigo: 'FJ' },
  { id: '74', name: 'Filipina', nomePais: 'Filipinas', codigo: 'PH' },
  { id: '75', name: 'Finlandesa', nomePais: 'Finlândia', codigo: 'FI' },
  { id: '76', name: 'Francesa', nomePais: 'França', codigo: 'FR' },
  { id: '77', name: 'Gabonesa', nomePais: 'Gabão', codigo: 'GA' },
  { id: '78', name: 'Gambiana', nomePais: 'Gâmbia', codigo: 'GM' },
  { id: '79', name: 'Ganense', nomePais: 'Gana', codigo: 'GH' },
  { id: '80', name: 'Georgiana', nomePais: 'Geórgia', codigo: 'GE' },
  { id: '81', name: 'Gibraltarina', nomePais: 'Gibraltar', codigo: 'GI' },
  { id: '82', name: 'Inglesa', nomePais: 'Grã-Bretanha (Reino Unido, UK)', codigo: 'GB' },
  { id: '83', name: 'Granadina', nomePais: 'Granada', codigo: 'GD' },
  { id: '84', name: 'Grega', nomePais: 'Grécia', codigo: 'GR' },
  { id: '85', name: 'Groenlandesa', nomePais: 'Groelândia', codigo: 'GL' },
  { id: '86', name: 'Guadalupense', nomePais: 'Guadalupe', codigo: 'GP' },
  { id: '87', name: 'Guamês', nomePais: 'Guam (Território dos Estados Unidos)', codigo: 'GU' },
  { id: '88', name: 'Guatemalteca', nomePais: 'Guatemala', codigo: 'GT' },
  { id: '89', name: 'Guernesiana', nomePais: 'Guernsey', codigo: 'GG' },
  { id: '90', name: 'Guianense', nomePais: 'Guiana', codigo: 'GY' },
  { id: '91', name: 'Franco-guianense', nomePais: 'Guiana Francesa', codigo: 'GF' },
  { id: '92', name: 'Guineana', nomePais: 'Guiné', codigo: 'GN' },
  { id: '93', name: 'Guinéu-equatoriana', nomePais: 'Guiné Equatorial', codigo: 'GQ' },
  { id: '94', name: 'Guineense', nomePais: 'Guiné-Bissau', codigo: 'GW' },
  { id: '95', name: 'Haitiana', nomePais: 'Haiti', codigo: 'HT' },
  { id: '96', name: 'Holandês', nomePais: 'Holanda', codigo: 'NL' },
  { id: '97', name: 'Hondurenha', nomePais: 'Honduras', codigo: 'HN' },
  { id: '98', name: 'Hong-konguiana', nomePais: 'Hong Kong', codigo: 'HK' },
  { id: '99', name: 'Húngara', nomePais: 'Hungria', codigo: 'HU' },
  { id: '100', name: 'Iemenita', nomePais: 'Iêmen', codigo: 'YE' },
  { id: '101', name: 'Da ilha Bouvet', nomePais: 'Ilha Bouvet', codigo: 'BV' },
  { id: '102', name: 'Da ilha de Ascensão', nomePais: 'Ilha de Ascensão', codigo: 'AC' },
  { id: '103', name: 'Da ilha de Clipperton', nomePais: 'Ilha de Clipperton', codigo: 'CP' },
  { id: '104', name: 'Manês', nomePais: 'Ilha de Man', codigo: 'IM' },
  { id: '105', name: 'Natalense', nomePais: 'Ilha Natal', codigo: 'CX' },
  { id: '106', name: 'Pitcairnesa', nomePais: 'Ilha Pitcairn', codigo: 'PN' },
  { id: '107', name: 'Reunionense', nomePais: 'Ilha Reunião', codigo: 'RE' },
  { id: '108', name: 'Alandesa', nomePais: 'Ilhas Aland', codigo: 'AX' },
  { id: '109', name: 'Caimanesa', nomePais: 'Ilhas Cayman', codigo: 'KY' },
  { id: '110', name: 'Das ilhas Cocos', nomePais: 'Ilhas Cocos', codigo: 'CC' },
  { id: '111', name: 'Cookense', nomePais: 'Ilhas Cook', codigo: 'CK' },
  { id: '112', name: 'Faroense', nomePais: 'Ilhas Faroes', codigo: 'FO' },
  { id: '113', name: 'Sul-georgiana', nomePais: 'Ilhas Geórgia do Sul e Sandwich do Sul', codigo: 'GS' },
  { id: '114', name: 'Das ilhas Heard e McDonald', nomePais: 'Ilhas Heard e McDonald (Território da Austrália)', codigo: 'HM' },
  { id: '115', name: 'Malvinense', nomePais: 'Ilhas Malvinas', codigo: 'FK' },
  { id: '116', name: 'Norte-marianense', nomePais: 'Ilhas Marianas do Norte', codigo: 'MP' },
  { id: '117', name: 'Marshallina', nomePais: 'Ilhas Marshall', codigo: 'MH' },
  { id: '118', name: 'Das ilhas Menores Distantes dos Estados Unidos', nomePais: 'Ilhas Menores dos Estados Unidos', codigo: 'UM' },
  { id: '119', name: 'Norfolquiana', nomePais: 'Ilhas Norfolk', codigo: 'NF' },
  { id: '120', name: 'Salomônica', nomePais: 'Ilhas Salomão', codigo: 'SB' },
  { id: '121', name: 'Seichelense', nomePais: 'Ilhas Seychelles', codigo: 'SC' },
  { id: '122', name: 'Toquelauana', nomePais: 'Ilhas Tokelau', codigo: 'TK' },
  { id: '123', name: 'Turquês', nomePais: 'Ilhas Turks e Caicos', codigo: 'TC' },
  { id: '124', name: 'Virginense (USA)', nomePais: 'Ilhas Virgens (Estados Unidos)', codigo: 'VI' },
  { id: '125', name: 'Virginense (UK)', nomePais: 'Ilhas Virgens (Inglaterra)', codigo: 'VG' },
  { id: '126', name: 'Indiano', nomePais: 'Índia', codigo: 'IN' },
  { id: '127', name: 'Indonésia', nomePais: 'Indonésia', codigo: 'ID' },
  { id: '128', name: 'Iraniano', nomePais: 'Irã', codigo: 'IR' },
  { id: '129', name: 'Iraquiana', nomePais: 'Iraque', codigo: 'IQ' },
  { id: '130', name: 'Irlandesa', nomePais: 'Irlanda', codigo: 'IE' },
  { id: '131', name: 'Islandesa', nomePais: 'Islândia', codigo: 'IS' },
  { id: '132', name: 'Israelense', nomePais: 'Israel', codigo: 'IL' },
  { id: '133', name: 'Italiana', nomePais: 'Itália', codigo: 'IT' },
  { id: '134', name: 'Jamaicana', nomePais: 'Jamaica', codigo: 'JM' },
  { id: '135', name: 'Japonesa', nomePais: 'Japão', codigo: 'JP' },
  { id: '136', name: 'Jersiana', nomePais: 'Jersey', codigo: 'JE' },
  { id: '137', name: 'Jordaniana', nomePais: 'Jordânia', codigo: 'JO' },
  { id: '138', name: 'Kiribatiana', nomePais: 'Kiribati', codigo: 'KI' },
  { id: '139', name: 'Kosovar', nomePais: 'Kosovo', codigo: 'XK' },
  { id: '140', name: 'Kuwaitiano', nomePais: 'Kuait', codigo: 'KW' },
  { id: '141', name: 'Laosiana', nomePais: 'Laos', codigo: 'LA' },
  { id: '142', name: 'Lesota', nomePais: 'Lesoto', codigo: 'LS' },
  { id: '143', name: 'Letão', nomePais: 'Letônia', codigo: 'LV' },
  { id: '144', name: 'Libanesa', nomePais: 'Líbano', codigo: 'LB' },
  { id: '145', name: 'Liberiana', nomePais: 'Libéria', codigo: 'LR' },
  { id: '146', name: 'Líbia', nomePais: 'Líbia', codigo: 'LY' },
  { id: '147', name: 'Liechtensteiniense', nomePais: 'Liechtenstein', codigo: 'LI' },
  { id: '148', name: 'Lituana', nomePais: 'Lituânia', codigo: 'LT' },
  { id: '149', name: 'Luxemburguesa', nomePais: 'Luxemburgo', codigo: 'LU' },
  { id: '150', name: 'Macauense', nomePais: 'Macau', codigo: 'MO' },
  { id: '151', name: 'Macedônio', nomePais: 'Macedônia (República Yugoslava)', codigo: 'MK' },
  { id: '152', name: 'Malgaxe', nomePais: 'Madagascar', codigo: 'MG' },
  { id: '153', name: 'Malaia', nomePais: 'Malásia', codigo: 'MY' },
  { id: '154', name: 'Malauiano', nomePais: 'Malaui', codigo: 'MW' },
  { id: '155', name: 'Maldívia', nomePais: 'Maldivas', codigo: 'MV' },
  { id: '156', name: 'Malinesa', nomePais: 'Mali', codigo: 'ML' },
  { id: '157', name: 'Maltesa', nomePais: 'Malta', codigo: 'MT' },
  { id: '158', name: 'Marroquina', nomePais: 'Marrocos', codigo: 'MA' },
  { id: '159', name: 'Martinicana', nomePais: 'Martinica', codigo: 'MQ' },
  { id: '160', name: 'Mauriciana', nomePais: 'Maurício', codigo: 'MU' },
  { id: '161', name: 'Mauritana', nomePais: 'Mauritânia', codigo: 'MR' },
  { id: '162', name: 'Maiotense', nomePais: 'Mayotte', codigo: 'YT' },
  { id: '163', name: 'Mexicana', nomePais: 'México', codigo: 'MX' },
  { id: '164', name: 'Micronésia', nomePais: 'Micronésia', codigo: 'FM' },
  { id: '165', name: 'Moçambicana', nomePais: 'Moçambique', codigo: 'MZ' },
  { id: '166', name: 'Moldavo', nomePais: 'Moldova', codigo: 'MD' },
  { id: '167', name: 'Monegasca', nomePais: 'Mônaco', codigo: 'MC' },
  { id: '168', name: 'Mongol', nomePais: 'Mongólia', codigo: 'MN' },
  { id: '169', name: 'Montenegrina', nomePais: 'Montenegro', codigo: 'ME' },
  { id: '170', name: 'Montserratiana', nomePais: 'Montserrat', codigo: 'MS' },
  { id: '171', name: 'Birmanês', nomePais: 'Myanma', codigo: 'MM' },
  { id: '172', name: 'Namíbia', nomePais: 'Namíbia', codigo: 'NA' },
  { id: '173', name: 'Nauruana', nomePais: 'Nauru', codigo: 'NR' },
  { id: '174', name: 'Nepalesa', nomePais: 'Nepal', codigo: 'NP' },
  { id: '175', name: 'Nicaraguense', nomePais: 'Nicarágua', codigo: 'NI' },
  { id: '176', name: 'Nigerina', nomePais: 'Níger', codigo: 'NE' },
  { id: '177', name: 'Nigeriana', nomePais: 'Nigéria', codigo: 'NG' },
  { id: '178', name: 'Niueana', nomePais: 'Niue', codigo: 'NU' },
  { id: '179', name: 'Norueguesa', nomePais: 'Noruega', codigo: 'NO' },
  { id: '180', name: 'Neocaledônia', nomePais: 'Nova Caledônia', codigo: 'NC' },
  { id: '181', name: 'Neozelandesa', nomePais: 'Nova Zelândia', codigo: 'NZ' },
  { id: '182', name: 'Omani', nomePais: 'Omã', codigo: 'OM' },
  { id: '183', name: 'Neerlandês caribenho', nomePais: 'Países Baixos Caribenhos', codigo: 'BQ' },
  { id: '184', name: 'Palauense', nomePais: 'Palau', codigo: 'PW' },
  { id: '185', name: 'Palestiniana', nomePais: 'Palestina', codigo: 'PS' },
  { id: '186', name: 'Panamense', nomePais: 'Panamá', codigo: 'PA' },
  { id: '187', name: 'Pauásia', nomePais: 'Papua-Nova Guiné', codigo: 'PG' },
  { id: '188', name: 'Paquistanesa', nomePais: 'Paquistão', codigo: 'PK' },
  { id: '189', name: 'Paraguaia', nomePais: 'Paraguai', codigo: 'PY' },
  { id: '190', name: 'Peruana', nomePais: 'Peru', codigo: 'PE' },
  { id: '191', name: 'Franco-polinésia', nomePais: 'Polinésia Francesa', codigo: 'PF' },
  { id: '192', name: 'Polonesa', nomePais: 'Polônia', codigo: 'PL' },
  { id: '193', name: 'Porto-riquenha', nomePais: 'Porto Rico', codigo: 'PR' },
  { id: '194', name: 'Portuguesa', nomePais: 'Portugal', codigo: 'PT' },
  { id: '195', name: 'Catarense', nomePais: 'Qatar', codigo: 'QA' },
  { id: '196', name: 'Queniano', nomePais: 'Quênia', codigo: 'KE' },
  { id: '197', name: 'Quirguiz', nomePais: 'Quirguistão', codigo: 'KG' },
  { id: '198', name: 'Centro-africana', nomePais: 'República Centro-Africana', codigo: 'CF' },
  { id: '199', name: 'Congolesa', nomePais: 'República Democrática do Congo', codigo: 'CD' },
  { id: '200', name: 'Dominicana', nomePais: 'República Dominicana', codigo: 'DO' },
  { id: '201', name: 'Tcheca', nomePais: 'República Tcheca', codigo: 'CZ' },
  { id: '202', name: 'Romena', nomePais: 'Romênia', codigo: 'RO' },
  { id: '203', name: 'Ruandesa', nomePais: 'Ruanda', codigo: 'RW' },
  { id: '204', name: 'Russa', nomePais: 'Rússia (antiga URSS) - Federação Russa', codigo: 'RU' },
  { id: '205', name: 'Saariana', nomePais: 'Saara Ocidental', codigo: 'EH' },
  { id: '206', name: 'Miquelonesa', nomePais: 'Saint-Pierre e Miquelon', codigo: 'PM' },
  { id: '207', name: 'Estadunidense', nomePais: 'Samoa Americana', codigo: 'AS' },
  { id: '208', name: 'Samoana', nomePais: 'Samoa Ocidental', codigo: 'WS' },
  { id: '209', name: 'Samarinês', nomePais: 'San Marino', codigo: 'SM' },
  { id: '210', name: 'Santa-helenense', nomePais: 'Santa Helena', codigo: 'SH' },
  { id: '211', name: 'Santa-lucense', nomePais: 'Santa Lúcia', codigo: 'LC' },
  { id: '212', name: 'São-bartolomeense', nomePais: 'São Bartolomeu', codigo: 'BL' },
  { id: '213', name: 'São-cristovense', nomePais: 'São Cristóvão e Névis', codigo: 'KN' },
  { id: '214', name: 'Da ilha de São Martinho', nomePais: 'São Martim', codigo: 'MF' },
  { id: '215', name: 'São-martinhense', nomePais: 'São Martinho', codigo: 'SX' },
  { id: '216', name: 'São-tomense', nomePais: 'São Tomé e Príncipe', codigo: 'ST' },
  { id: '217', name: 'São-vicentina', nomePais: 'São Vicente e Granadinas', codigo: 'VC' },
  { id: '218', name: 'Senegalesa', nomePais: 'Senegal', codigo: 'SN' },
  { id: '219', name: 'Serra-leonesa', nomePais: 'Serra Leoa', codigo: 'SL' },
  { id: '220', name: 'Sérvia', nomePais: 'Sérvia', codigo: 'RS' },
  { id: '221', name: 'Síria', nomePais: 'Síria', codigo: 'SY' },
  { id: '222', name: 'Somali', nomePais: 'Somália', codigo: 'SO' },
  { id: '223', name: 'Cingalesa', nomePais: 'Sri Lanka', codigo: 'LK' },
  { id: '224', name: 'Suazi', nomePais: 'Suazilândia', codigo: 'SZ' },
  { id: '225', name: 'Sudanesa', nomePais: 'Sudão', codigo: 'SD' },
  { id: '226', name: 'Sul-sudanesa', nomePais: 'Sudão do Sul', codigo: 'SS' },
  { id: '227', name: 'Sueca', nomePais: 'Suécia', codigo: 'SE' },
  { id: '228', name: 'Suíça', nomePais: 'Suíça', codigo: 'CH' },
  { id: '229', name: 'Surinamesa', nomePais: 'Suriname', codigo: 'SR' },
  { id: '230', name: 'Svalbardense', nomePais: 'Svalbard', codigo: 'SJ' },
  { id: '231', name: 'Tadjique', nomePais: 'Tadjiquistão', codigo: 'TJ' },
  { id: '232', name: 'Tailandesa', nomePais: 'Tailândia', codigo: 'TH' },
  { id: '233', name: 'Taiwanês', nomePais: 'Taiwan', codigo: 'TW' },
  { id: '234', name: 'Tanzaniana', nomePais: 'Tanzânia', codigo: 'TZ' },
  { id: '235', name: 'Do território Britânico do Oceano Índico', nomePais: 'Território Britânico do Oceano índico', codigo: 'IO' },
  { id: '236', name: 'De terras Austrais e Antárticas Francesas', nomePais: 'Territórios do Sul da França', codigo: 'TF' },
  { id: '237', name: 'Timorense', nomePais: 'Timor-Leste', codigo: 'TL' },
  { id: '238', name: 'Togolesa', nomePais: 'Togo', codigo: 'TG' },
  { id: '239', name: 'Tonganesa', nomePais: 'Tonga', codigo: 'TO' },
  { id: '240', name: 'Trinitária', nomePais: 'Trinidad e Tobago', codigo: 'TT' },
  { id: '241', name: 'Tristanita', nomePais: 'Tristão da Cunha', codigo: 'TA' },
  { id: '242', name: 'Tunisiana', nomePais: 'Tunísia', codigo: 'TN' },
  { id: '243', name: 'Turcomena', nomePais: 'Turcomenistão', codigo: 'TM' },
  { id: '244', name: 'Turca', nomePais: 'Turquia', codigo: 'TR' },
  { id: '245', name: 'Tuvaluana', nomePais: 'Tuvalu', codigo: 'TV' },
  { id: '246', name: 'Ucraniana', nomePais: 'Ucrânia', codigo: 'UA' },
  { id: '247', name: 'Ugandense', nomePais: 'Uganda', codigo: 'UG' },
  { id: '248', name: 'Uruguaia', nomePais: 'Uruguai', codigo: 'UY' },
  { id: '249', name: 'Uzbeque', nomePais: 'Uzbequistão', codigo: 'UZ' },
  { id: '250', name: 'Vanuatuense', nomePais: 'Vanuatu', codigo: 'VU' },
  { id: '251', name: 'Vaticana', nomePais: 'Vaticano', codigo: 'VA' },
  { id: '252', name: 'Venezuelana', nomePais: 'Venezuela', codigo: 'VE' },
  { id: '253', name: 'Vietnamita', nomePais: 'Vietnã', codigo: 'VN' },
  { id: '254', name: 'Wallisiana', nomePais: 'Wallis e Futuna', codigo: 'WF' },
  { id: '255', name: 'Zambiana', nomePais: 'Zâmbia', codigo: 'ZM' },
  { id: '256', name: 'Zimbabuana', nomePais: 'Zimbábue', codigo: 'ZW' }
]



// WEBPACK FOOTER //
// ./src/constants/gentilico-titulo.js